import APIUrl from "../../APIUrl";
import axios from "axios";

export const GET_STATS = "GET_STATS";

export function getStatsAction(stats) {
  return { type: GET_STATS, stats: stats };
}

const getExport = (APIUrl, successCallback) => {
  return function (dispatch) {
    return axios
      .get(APIUrl, { responseType: "arraybuffer" })
      .then(function (response) {
        if (response) {
          return successCallback(response);
        }
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const getConnections = function (successCallback) {
  return getExport(APIUrl.getConnections, successCallback);
};

export const getE4collEstablishments = function (successCallback) {
  return getExport(APIUrl.getE4collEstablishments, successCallback);
};

export const getE4collMercurials = function (successCallback) {
  return getExport(APIUrl.getE4collMercurials, successCallback);
};

export const getE4collInterventions = function (successCallback) {
  return getExport(APIUrl.getE4collInterventions, successCallback);
};

export const getE4collMaintenances = function (successCallback) {
  return getExport(APIUrl.getE4collMaintenances, successCallback);
};

export const getE4collDm = function (successCallback) {
  return getExport(APIUrl.getE4collDm, successCallback);
};

export const getE4madPrescribers = function (successCallback) {
  return getExport(APIUrl.getE4madPrescribers, successCallback);
};

export const getE4madPatients = function (successCallback) {
  return getExport(APIUrl.getE4madPatients, successCallback);
};

export const getE4madMercurials = function (successCallback) {
  return getExport(APIUrl.getE4madMercurials, successCallback);
};

export const getE4madInterventions = function (successCallback) {
  return getExport(APIUrl.getE4madInterventions, successCallback);
};

export const getE4madMaintenances = function (successCallback) {
  return getExport(APIUrl.getE4madMaintenances, successCallback);
};

export const getE4madAuditHome = function (successCallback) {
  return getExport(APIUrl.getE4madAuditHome, successCallback);
};

export const getE4madAuditDesk = function (successCallback) {
  return getExport(APIUrl.getE4madAuditDesk, successCallback);
};

export const getE4vhpEstablishments = function (successCallback) {
  return getExport(APIUrl.getE4vhpEstablishments, successCallback);
};

export const getE4vhpPatients = function (successCallback) {
  return getExport(APIUrl.getE4vhpPatients, successCallback);
};

export const getE4vhpExpressionNeeds = function (successCallback) {
  return getExport(APIUrl.getE4vhpExpressionNeeds, successCallback);
};

export const getE4vhpAnthropometricMeasurements = function (successCallback) {
  return getExport(APIUrl.getE4vhpAnthropometricMeasurements, successCallback);
};

export const getE4vhpTrials = function (successCallback) {
  return getExport(APIUrl.getE4vhpTrials, successCallback);
};

export const getE4vhpHomeAssessments = function (successCallback) {
  return getExport(APIUrl.getE4vhpHomeAssessments, successCallback);
};
